// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fdaf67e8","498":"d2168b58","703":"2fc2ba22"}[chunkId] + ".chunk.js";
};